/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EstimateBillingFromPageCounts200ResponseDocumentsInner
 */
export interface EstimateBillingFromPageCounts200ResponseDocumentsInner {
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200ResponseDocumentsInner
     */
    pages: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200ResponseDocumentsInner
     */
    credits: number;
    /**
     * 
     * @type {number}
     * @memberof EstimateBillingFromPageCounts200ResponseDocumentsInner
     */
    costCents: number;
}

/**
 * Check if a given object implements the EstimateBillingFromPageCounts200ResponseDocumentsInner interface.
 */
export function instanceOfEstimateBillingFromPageCounts200ResponseDocumentsInner(value: object): value is EstimateBillingFromPageCounts200ResponseDocumentsInner {
    if (!('pages' in value) || value['pages'] === undefined) return false;
    if (!('credits' in value) || value['credits'] === undefined) return false;
    if (!('costCents' in value) || value['costCents'] === undefined) return false;
    return true;
}

export function EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSON(json: any): EstimateBillingFromPageCounts200ResponseDocumentsInner {
    return EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSONTyped(json, false);
}

export function EstimateBillingFromPageCounts200ResponseDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EstimateBillingFromPageCounts200ResponseDocumentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'pages': json['pages'],
        'credits': json['credits'],
        'costCents': json['costCents'],
    };
}

export function EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSON(json: any): EstimateBillingFromPageCounts200ResponseDocumentsInner {
    return EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSONTyped(json, false);
}

export function EstimateBillingFromPageCounts200ResponseDocumentsInnerToJSONTyped(value?: EstimateBillingFromPageCounts200ResponseDocumentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pages': value['pages'],
        'credits': value['credits'],
        'costCents': value['costCents'],
    };
}

